import React, { useEffect, useState } from 'react';

interface EditNoteModalProps {
    currentNote: string | null;
    onSave: (note: string) => void;
    onCancel: () => void;
}

const EditNoteModal: React.FC<EditNoteModalProps> = ({
    currentNote,
    onSave,
    onCancel,
}) => {
    const [note, setNote] = useState(currentNote || '');

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onCancel();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onCancel]);

    const handleSubmit = () => {
        onSave(note.trim());
    };

    return (
        <div
            onClick={onCancel}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
                padding: '20px',
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '30px',
                    maxWidth: '500px',
                    width: '100%',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#333' }}>
                    Upraviť poznámku
                </h3>

                <textarea
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Sem napíšte svoju poznámku k bločku..."
                    autoFocus
                    style={{
                        width: '100%',
                        minHeight: '120px',
                        padding: '12px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                        marginBottom: '20px',
                        boxSizing: 'border-box',
                    }}
                />

                <p style={{ fontSize: '12px', color: '#666', marginBottom: '20px' }}>
                    Poznámka sa uloží k bločku a bude viditeľná len pre vás.
                </p>

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    >
                        Zrušiť
                    </button>
                    <button
                        onClick={handleSubmit}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#667eea',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                        }}
                    >
                        Uložiť
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditNoteModal;
